import * as moment from 'moment-timezone'

const TIMEZONE_ABBREVIATIONS = Object.freeze([
  "DST",
  "U",
  "HST",
  "AKDT",
  "PDT",
  "PST",
  "UMST",
  "MDT",
  "CAST",
  "CDT",
  "CCST",
  "SPST",
  "EDT",
  "UEDT",
  "VST",
  "PYT",
  "ADT",
  "CBST",
  "SWST",
  "PSST",
  "NDT",
  "ESAST",
  "AST",
  "SEST",
  "GDT",
  "MST",
  "BST",
  "CVST",
  "UTC",
  "GMT",
  "GST",
  "WEDT",
  "CEDT",
  "RDT",
  "WCAST",
  "NST",
  "MEDT",
  "EST",
  "SDT",
  "EEDT",
  "SAST",
  "FDT",
  "TDT",
  "JDT",
  "LST",
  "JST",
  "KST",
  "EAST",
  "MSK",
  "SAMT",
  "IDT",
  "CST",
  "WAST",
  "YEKT",
  "PKT",
  "IST",
  "SLST",
  "NCAST",
  "NAST",
  "MPST",
  "TST",
  "UST",
  "NAEST",
  "ACST",
  "AEST",
  "WPST",
  "YST",
  "CPST",
  "NZST",
  "FST",
  "KDT",
  "SST"
])

// https://stackoverflow.com/questions/23640227/how-does-gmt-ids-work-in-java-timezone/23643847#23643847
const POSIX_SIGN_TIMEZONE_REGEX = /^Etc\/GMT([+,-][^0][\d]{0,1})$/

export const normalizedTimezone = (timezone) => {
  const [isPosixSignTimezone, offsetValue] = timezone.match(POSIX_SIGN_TIMEZONE_REGEX) || []

  if (!isPosixSignTimezone) {
    return timezone
  }

  const normalizedOffsetValue = -offsetValue
  const normalizedOffsetLabel = (normalizedOffsetValue > 0)
    ? `+${normalizedOffsetValue}`
    : normalizedOffsetValue

  return `UTC/GMT${normalizedOffsetLabel}`
}

export const getSupportedTimezones = () => moment.tz.names().filter(x => !TIMEZONE_ABBREVIATIONS.includes(x))

export const getTimezoneMetadata = (timezone, date) => {
  const timestamp = date.getTime()
  const zone = moment.tz.zone(timezone)
  const zonedDate = moment.tz(timestamp, timezone)
  const offsetAsString = zonedDate.format('Z')

  const abbrs = zone.abbr(timestamp)

  return {
    name: zone.name,
    abbreviations: abbrs,
    offset: offsetAsString
  }
}


// WEBPACK FOOTER //
// ./src/scripts/utils/timezoneHelpers.js